"use client"

import React, { PropsWithChildren } from "react"
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3"

import { getLanguageFromIsoLocale } from "@/lib/locale/locale-common-utils"

interface GoogleReCaptchaWrapperProps extends PropsWithChildren {
  domainKey: string
  isoLocale: string
}

const GoogleReCaptchaWrapperClient = (props: GoogleReCaptchaWrapperProps) => {
  const language = getLanguageFromIsoLocale(props.isoLocale)

  return (
    <>
      <style jsx global>{`
        .grecaptcha-badge {
          bottom: 51px !important;
        }
      `}</style>
      <GoogleReCaptchaProvider
        reCaptchaKey={props.domainKey ?? "NOT DEFINED"}
        scriptProps={{
          async: false,
          defer: false,
          appendTo: "head",
          nonce: undefined,
        }}
        language={language}
      >
        {props.children}
      </GoogleReCaptchaProvider>
    </>
  )
}

export default GoogleReCaptchaWrapperClient
